import { useEffect, useState } from 'react';

import { AuthApi } from '@atlas/core';

import { paymentTypes, transactionStatuses } from 'src/common/constants';

const PAYMENT_HISTORY_ITEMS_COUNT = 30;

const clampAmountToLimits = (amount, pm) => {
  if (!pm) return amount;
  const numAmount = Number(amount);
  if (!numAmount || Number.isNaN(numAmount)) return amount;

  if (pm.minAmount && numAmount < pm.minAmount) return pm.minAmount;
  if (pm.maxAmount && numAmount > pm.maxAmount) return pm.maxAmount;
  return amount;
};

export const useInitialPayment = paymentMethods => {
  const [completedPaymentMethod, setCompletedPaymentMethod] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [initialValue, setInitialValue] = useState('');

  useEffect(() => {
    AuthApi.getClientPaymentsHistory({
      currentSlice: 0,
      itemsPerSlice: PAYMENT_HISTORY_ITEMS_COUNT,
      operation: paymentTypes.DEPOSIT,
    }).then(({ items }) => {
      const successfulPayment = items.find(pm => pm.status === transactionStatuses.SUCCESS) || {};
      setCompletedPaymentMethod(successfulPayment);
    });
  }, []);

  useEffect(() => {
    if (paymentMethods.length > 0 && completedPaymentMethod) {
      const foundPaymentMethod = paymentMethods.find(
        pm => pm.id === completedPaymentMethod.paymentMethodId,
      );

      if (foundPaymentMethod) {
        setPaymentMethod(foundPaymentMethod);
        setInitialValue(clampAmountToLimits(completedPaymentMethod.amount, foundPaymentMethod));
      } else {
        setPaymentMethod(paymentMethods[0]);
      }
    }
  }, [paymentMethods, completedPaymentMethod]);

  return { initialValue, paymentMethod, setPaymentMethod };
};
